import React from 'react';
import { Hidden } from '@material-ui/core';
import './sobre-commodities.css';
import { Submenu, SubmenuItem } from '../../components';
import { documentsService } from '../../service';

import { getDateTimeString, smoothScroll } from '../../utils/functions';

export default () => {
	const getFile = async path => {
		try {
			const response = await documentsService.downloadDocumento(path);
			const responseData = await response.data;

			const blob = new Blob([responseData], {
				type: 'application/pdf',
			});

			const downloadUrl = window.URL.createObjectURL(blob);

			const link = document.createElement('a');

			link.href = downloadUrl;
			link.download = `${path.replace('/', '')}PDF_${getDateTimeString()}.pdf`;

			document.body.appendChild(link);

			link.click();
			link.remove();
		} catch (err) {
			console.error(
				'Ocorreu um erro ao chamar a API de Download - Erro: ',
				err,
			);
		}
	};


	const handleDownloadClick = path => getFile(path);

	return (
		<div className="sobre-commodities">
			<Hidden mdUp>
				<h1 className="titulohSobre1">Sobre Commodities e ETF</h1>
			</Hidden>
			<Hidden smDown>
				<Submenu>
					<SubmenuItem
						onClick={() => smoothScroll('#commodities')}
						label="O que é o Commodities"
					/>
					<SubmenuItem
						onClick={() => smoothScroll('#etf')}
						label="O que são ETFs"
					/>
					<SubmenuItem
						onClick={() => smoothScroll('#etfbtg')}
						label="O ETF Commodities do BTG Pactual (CMDB11)"
					/>
				</Submenu>
			</Hidden>

			<div className="oqueecommodities">
				<div className="conteudooquecommodities">
					<div className="conteudoconteudooquecommodities">
						<h2 id="commodities" className="corazulclaro titulo">
							O QUE É O COMMODITIES
						</h2>
						<p className="corbranca texto">
							O Índice Teva Ações Commodities Brasil é um índice de mercado criado pela Teva Indices que busca
							representar o desempenho médio das ações de empresas produtoras e exportadoras 
							de <i>commodities</i> negociadas na Bolsa do mercado brasileiro, a B3. É um índice de retorno total, portanto
							considera a variação dos preços das ações e também as distribuições de proventos realizadas ao
							longo do tempo.
						</p>
						<br />
						<p className="corbranca texto">
							Ele é composto de ações e <i>units</i> de companhias listadas na B3. Além disso, o Índice Teva Ações Commodities Brasil
							é rebalanceado 4 vezes ao ano. Assim, todas as ações listadas na B3 são reavaliadas 
							e a nova composição do Índice é divulgada ao mercado.
						</p>
						<br />
						<p className="corbranca texto">
							As companhias que compõem o índice possuem foco de atuação em produção de alimentos de carnes e 
							derivados, papel e celulose, mineração e metalurgia, açúcar e álcool, extração de petróleo e 
							produção agrícola. Estima-se que estes setores cobrem cerca de 97% da cesta de exportações de 
							commodities brasileiras, que por sua vez representam certa de 65% das exportações nacionais.
						</p>
						<br />
						
					</div>
				</div>
			</div>
			<div className="sobreetf">
				<div className="conteudosobreetf">
					<h2 id="etf" className="corazulesc titulo">
						O QUE SÃO ETFs
					</h2>

					<div className="conteudosobreetftexto">
						<div className="conteudosobreetftextografico">
							<img
								src="images/mistura-fundos-ativos.svg"
								alt="Gráfico mistura entre Fundos e Ativos, virando ETF."
							/>
						</div>
						<div className="conteudosobreetftextointerno">
							<p className="texto">
								Os ETFs (do inglês <i>Exchange Traded Fund</i>) ou fundos de
								índice são fundos negociados em bolsa, que replicam carteiras de
								índices, permitindo que os investidores tenham acesso a um
								universo amplo de ativos de forma eficiente, transparente e
								flexível. No mercado brasileiro, os ETFs são classificados como
								de renda variável, renda fixa ou internacional.
							</p>{' '}
							<br />
							<p className="texto">
								Os ETFs combinam o melhor dos dois mundos: estrutura dos fundos
								de investimento e a flexibilidade de negociação de ativos
								individuais.
							</p>
						</div>
					</div>
					<h3 className="oquesaoh3 corazulclaro titulo">BENEFÍCIOS</h3>
					<div className="oquesaoblocomaster">
						<div className="oquesaobloco">
							<div className="oquesaonumerocirculo">1</div>
							<h3 className="corazulclaro titulobloco">Diversificação</h3>
							<p className="texto corbranca textop1">
								ETFs diversificam as carteiras dos investidores e reduzem risco
								de concentração de investimento.
							</p>
						</div>
						<div className="oquesaobloco">
							<div className="oquesaonumerocirculo">2</div>
							<h3 className="corazulclaro titulobloco">Flexibilidade</h3>
							<p className="texto corbranca textop2">
								Permitem maior acesso a diferentes mercados e classes de ativos.
							</p>
						</div>
						<div className="oquesaobloco">
							<div className="oquesaonumerocirculo">3</div>
							<h3 className="corazulclaro titulobloco textop3">
								Simplificação
							</h3>
							<p className="texto corbranca">
								ETFs são fáceis de negociar - funcionam como ações que podem ser
								compradas e vendidas ao longo do dia na Bolsa de Valores.
							</p>
						</div>
						<div className="oquesaobloco">
							<div className="oquesaonumerocirculo">4</div>
							<h3 className="corazulclaro titulobloco">Transparência</h3>
							<p className="texto corbranca textop4">
								Sua cesta de ativos é divulgada diariamente.
							</p>
						</div>
						<div className="oquesaobloco">
							<div className="oquesaonumerocirculo">5</div>
							<h3 className="corazulclaro titulobloco">Custo</h3>
							<p className="texto corbranca textop5">
								Taxas de administração mais baixas do que de fundos ativos.
							</p>
						</div>
					</div>
					<p className="texto oquesaotextobeneficios">
						De forma geral, os ETFs conseguem oferecer uma série de benefícios
						quando comparados com outros produtos de investimento.
					</p>

					<h3 className="oquesaoh3 corazulclaro titulo">
						PRINCIPAIS DIFERENÇAS E VANTAGENS DE ETFs VS OUTROS INVESTIMENTOS
					</h3>

					<div className="oquesaovantagens">
						<div className="tabeladiferencas">
							<table className="tabeladiferencastabela">
								<thead className="">
									<tr>
										<th className="tabeladiferencastabelatitulo">
											CARACTERÍSTICA
										</th>
										<th style={{ textTransform: 'none' }}>ETFs</th>
										<th>Ativos</th>
										<th>Fundos Ativos</th>
										<th>Fundos Passivos</th>
									</tr>
								</thead>
								<tbody className="">
									<tr className="">
										<td className="celulaescrita">
											<p>Liquidez</p>
										</td>
										<td className="iconeok celulaazul">
											<p>
												<img src="images/sim-verde-calro.svg" alt="Tem" />
											</p>
										</td>
										<td className="iconeok">
											<p>
												<img src="images/sim-verde-escuro.svg" alt="Tem" />
											</p>
										</td>
										<td className="iconesem">
											<p>
												<img
													src="images/sem-vermelho-escuro.svg"
													alt="Não tem"
												/>
											</p>
										</td>
										<td className="iconesem">
											<p>
												<img
													src="images/sem-vermelho-escuro.svg"
													alt="Não tem"
												/>
											</p>
										</td>
									</tr>
									<tr className="">
										<td className="celulaescrita">
											<p>Transação via corretora de investimentos</p>
										</td>
										<td className="iconeok celulaazul">
											<p>
												<img src="images/sim-verde-calro.svg" alt="Tem" />
											</p>
										</td>
										<td className="iconeok">
											<p>
												<img src="images/sim-verde-escuro.svg" alt="Tem" />
											</p>
										</td>
										<td className="iconesem">
											<p>
												<img
													src="images/sem-vermelho-escuro.svg"
													alt="Não tem"
												/>
											</p>
										</td>
										<td className="iconesem">
											<p>
												<img
													src="images/sem-vermelho-escuro.svg"
													alt="Não tem"
												/>
											</p>
										</td>
									</tr>
									<tr className="">
										<td className="celulaescrita">
											<p>Investimento mínimo</p>
										</td>
										<td className="iconesem celulaazul">
											<p>
												<img
													src="images/sem-vermelho-claro.svg"
													alt="Não tem"
												/>
											</p>
										</td>
										<td className="iconesem">
											<img src="images/sem-vermelho-escuro.svg" alt="Não tem" />
										</td>
										<td className="iconeok">
											<p>
												<img src="images/sim-verde-escuro.svg" alt="Tem" />
											</p>
										</td>
										<td className="iconeok">
											<p>
												<img src="images/sim-verde-escuro.svg" alt="Tem" />
											</p>
										</td>
									</tr>
									<tr className="">
										<td className="celulaescrita">
											<p>Gestão indexada a benchmark</p>
										</td>
										<td className="iconeok celulaazul">
											<p>
												<img src="images/sim-verde-calro.svg" alt="Tem" />
											</p>
										</td>
										<td className="iconesem">
											<p>
												<img
													src="images/sem-vermelho-escuro.svg"
													alt="Não tem"
												/>
											</p>
										</td>
										<td className="iconesem">
											<p>
												<img
													src="images/sem-vermelho-escuro.svg"
													alt="Não tem"
												/>
											</p>
										</td>
										<td className="iconeok">
											<p>
												<img src="images/sim-verde-escuro.svg" alt="Tem" />
											</p>
										</td>
									</tr>
									<tr className="">
										<td className="celulaescrita">
											<p>Diversificação de portfólio</p>
										</td>
										<td className="iconeok celulaazul">
											<p>
												<img src="images/sim-verde-calro.svg" alt="Tem" />
											</p>
										</td>
										<td className="iconesem">
											<p>
												<img
													src="images/sem-vermelho-escuro.svg"
													alt="Não tem"
												/>
											</p>
										</td>
										<td className="iconeok">
											<p>
												<img src="images/sim-verde-escuro.svg" alt="Tem" />
											</p>
										</td>
										<td className="iconeok">
											<p>
												<img src="images/sim-verde-escuro.svg" alt="Tem" />
											</p>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
						<div className="imagemdiferencas" />
					</div>
				</div>
			</div>
			<div className="oetfbtg">
				<div className="conteudooetfbtg">
					<h2 id="etfbtg" className="corazulesc titulo">
						O ETF COMMODITIES DO BTG PACTUAL (CMDB11)
					</h2>
					<p className="texto">
						O ETF CMDB11 replica o Índice Teva Ações Commodities Brasil.
						Este índice tem como objetivo medir a performance 
						das ações de empresas produtoras e exportadoras de 
						<i> commodities</i> do mercado de ações brasileiro. O índice 
						adota como principal fator de seleção o nível de capitalização 
						das empresas. A metodologia é proprietária da Teva Indices.
					</p>
					<p className="corazulesc textoetfbtg">
						Em nossa visão, o Índice Teva Ações Commodities Brasil possui 2 
						grandes diferenciais:
					</p>
				</div>
			</div>
			<div className="conteudooetfbtgbloco">
				<div className="conteudooetfbtgblocointerno">
					<div className="conteudooetfbtgbloco1">
						<div className="numerocirculo">1</div>
						<p className="texto corbranca">
							Ele é descorrelacionado com o restante do mercado;
						</p>
					</div>
					<div className="conteudooetfbtgblocotraco">
						<div className="tracoseparador" />
					</div>
					<div className="conteudooetfbtgbloco2">
						<div className="numerocirculo">2</div>
						<p className="texto corbranca textomargin">
							Ele captura cerca de 97% do setor brasileiro de <i>commodities</i>, onde o Brasil é um dos principais produtores e exportadores do mundo.
						</p>
					</div>
				</div>
			</div>
			<div className="conteudooetfbtgrafico">
				<div className="conteudooetfbtgraficointerno">
					<div className="conteudooetfbtgraficointernobloco1">
						<p className="corazulesc textoetfbtggrafico textograficocima">
							Para a criação do Índice, são aplicados os seguintes filtros:
						</p>
						<div className="topicosetfbtggrafico">
							<span>
								<img src="images/seta.png" alt="seta" />
								<p>
									Empresas produtoras de commodities pela Classificação Setorial Teva Indices;    
								</p>
							</span>
							<span>
								<img src="images/seta.png" alt="seta" />
								<p>
									Capitalização de mercado superior a R$ 500 milhões;
								</p>
							</span>
							<span>
								<img src="images/seta.png" alt="seta" />
								<p>
									Volume mensal de negociação igual ou superior a R$ 100 milhões;
								</p>
							</span>
							<span>
								<img src="images/seta.png" alt="seta" />
								<p>
								Mínimo de 4% da capitalização de mercado em <i>free float</i>.
								</p>
							</span>
						</div>
						<p className="corazulesc textoetfbtggrafico">
							Posteriormente, o Índice usa como critério de ponderação a capitalização de mercado 
							<i> free float</i>, respeitando o limite de peso máximo de 20% por emissor.
						</p>
					</div>
					<div className="conteudooetfbtgraficointernobloco2">
						<img
							src="images/grafico-para-criacao-do-indice_novo.png"
							alt="indiceetfbtg"
						/>
					</div>
				</div>
			</div>
			<div className="conteudooetfbtgraficoparaacessar">
				<div className="conteudooetfbtgraficoblocoparaacessar">
					Para acessar a metodologia completa do Índice Teva Ações Commodities Brasil, {' '}
					<strong
						onClick={() =>
							handleDownloadClick('/Caracteristicas/MetodologiaIndice')
						}
					>
						clique aqui
					</strong>{' '}
					ou acesse o menu Documentos &gt; Metodologia do Índice.
				</div>
			</div>
		</div>
	);
};
